/**
 * Field-mapping import API routes (SM Field Mapping 2026).
 * Legacy routes remain on importCompany / parts_Inventory / requirement for backward compatibility.
 */
export const IMPORT_API = {
  common: {
    validateUpload: 'app/importCommon/validateUpload',
    getHeaderNameListFromFile: 'app/importCommon/getHeaderNameListFromFile',
    validateFileWithTemplate: 'app/importCommon/validateFileWithTemplate',
    validateFileHasData: 'app/importCommon/validateFileHasData',
    validateMapping: 'app/importCommon/validateMapping',
    deleteTemplateByTemplateId: 'app/importCommon/deleteTemplateByTemplateId',
    getTemplateByTemplateId: 'app/importCommon/getTemplateByTemplateId',
    getModuleFields: 'app/importCommon/getModuleFields',
    autoMapFields: 'app/importCommon/autoMapFields',
    buildWorkflowStep: 'app/importCommon/buildWorkflowStep',
    downloadErrorReport: 'app/importCommon/downloadErrorReport',
    downloadImportSummary: 'app/importCommon/downloadImportSummary',
  },
  crm: {
    importCompanyTemplate: 'app/importCrm/importCompanyTemplate',
    importCompany: 'app/importCrm/importCompany',
  },
  parts: {
    importPartTemplate: 'app/importParts/importPartTemplate',
    importPart: 'app/importParts/importPart',
    importInventoryTemplate: 'app/importParts/importInventoryTemplate',
    importInventory: 'app/importParts/importInventory',
    importConsignmentTemplate: 'app/importParts/importConsignmentTemplate',
    importConsignment: 'app/importParts/importConsignment',
    importVendorPartTemplate: 'app/importParts/importVendorPartTemplate',
    importVendorPart: 'app/importParts/importVendorPart',
    importOEMExcessTemplate: 'app/importParts/importOEMExcessTemplate',
    importOEMExcess: 'app/importParts/importOEMExcess',
    importOfferTemplate: 'app/importParts/importOfferTemplate',
    importOffer: 'app/importParts/importOffer',
  },
  sales: {
    importRequirementTemplate: 'app/importSales/importRequirementTemplate',
    importRequirementRecords: 'app/importSales/importRequirementRecords',
  },
  master: {
    importCodeCrosswalkTemplate: 'app/importMaster/importCodeCrosswalkTemplate',
    importCodeCrosswalk: 'app/importMaster/importCodeCrosswalk',
  },
};
